// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xoElt24JJY8sgnJ5fQjJ [role=row] [role=cell]{width:15%}.xoElt24JJY8sgnJ5fQjJ [role=row] [role=cell]:nth-child(5){width:40%}`, "",{"version":3,"sources":["webpack://./src/page-components/save/workflow-prompt-statuses.module.scss"],"names":[],"mappings":"AAEI,6CACE,SAAA,CAEA,0DACE,SAAA","sourcesContent":[".table {\n  [role=\"row\"] {\n    [role=\"cell\"] {\n      width: 15%;\n\n      &:nth-child(5) {\n        width: 40%;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `xoElt24JJY8sgnJ5fQjJ`
};
export default ___CSS_LOADER_EXPORT___;
